import React, { useState } from "react";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/material/styles";
import GrButton from "src/design-system/components/GrButton";
import GrIcon from "src/design-system/components/GrIcon";
import icons from "src/design-system/icons";
import { gr } from "src/design-system/tokens";

// Action bar of a feed post (feed, dashboard, post popup / page): equal-width quiet buttons
// Like / Liked, Comment and, on another member's post, Send Coins. The hairlines above and below
// come from the post (its <hr />s). Liked = red heart + red text; the heart pops once when liked.
const pop = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.3); }
  100% { transform: scale(1); }
`;

const barSx = { display: "flex", gap: gr.space[1] };
const actionSx = {
  flex: "1 1 0",
  color: gr.color.ink2,
  fontWeight: gr.font.weight.medium,
  "&:hover": { background: gr.color.tint, color: gr.color.ink },
};
const likedSx = {
  ...actionSx,
  color: gr.color.danger,
  "&:hover": { background: gr.color.dangerSoft, color: gr.color.danger },
};
const heartSx = {
  display: "inline-flex",
  "&.is-popping": {
    animation: `${pop} 200ms ease-out`,
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  },
};

export default function HandleAction({
  isLiked,
  handleFeedAction,
  setShowAddComment,
  feed_id,
  showAddComment,
  sendCoins,
  setSendCoins,
  feeds_list,
}) {
  // Visual only: plays the heart "pop" after the member taps Like.
  const [popping, setPopping] = useState(false);

  const handleShowReplyInput = () => {
    if (showAddComment) {
      setShowAddComment(false);
    } else {
      setShowAddComment(true);
    }
  };

  const handleCoinsPopup = () => {
    if (sendCoins) {
      setSendCoins(false);
    } else {
      setSendCoins(true);
    }
  };

  const showSendCoins =
    !feeds_list.is_self && feeds_list.created_by.user_type === "member_user";

  return (
    <Box sx={barSx} className="feed-actions">
      {isLiked ? (
        <GrButton
          variant="text"
          sx={likedSx}
          startIcon={
            <Box
              component="span"
              sx={heartSx}
              className={popping ? "is-popping" : undefined}
              onAnimationEnd={() => setPopping(false)}
            >
              <GrIcon icon={icons.heartFilled} size="md" />
            </Box>
          }
          onClick={() => {
            handleFeedAction(feed_id, "feedunlike");
          }}
        >
          Liked
        </GrButton>
      ) : (
        <GrButton
          variant="text"
          sx={actionSx}
          startIcon={<GrIcon icon={icons.heart} />}
          onClick={() => {
            setPopping(true);
            handleFeedAction(feed_id, "feedlike");
          }}
        >
          Like
        </GrButton>
      )}
      <GrButton
        variant="text"
        sx={actionSx}
        startIcon={<GrIcon icon={icons.chat} />}
        onClick={handleShowReplyInput}
      >
        Comment
      </GrButton>
      {showSendCoins && (
        <GrButton
          variant="text"
          sx={actionSx}
          startIcon={<GrIcon icon={icons.award} />}
          onClick={handleCoinsPopup}
        >
          Send Coins
        </GrButton>
      )}
    </Box>
  );
}
